import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useLoja } from './LojaContext';
import { Button } from '../../components/ui/button';
import { Card } from '../../components/ui/card';
import { Trash2, Plus, Minus, ShoppingBag, ArrowRight } from 'lucide-react';

export default function LojaCart() {
  const { cart, cartTotal, removeFromCart, updateQty, user } = useLoja();
  const navigate = useNavigate();

  if (cart.length === 0) {
    return (
      <div className="text-center py-16">
        <ShoppingBag className="w-16 h-16 text-slate-600 mx-auto mb-4" />
        <h2 className="text-xl font-bold mb-2">Carrinho vazio</h2>
        <p className="text-slate-400 mb-6">Adicione produtos para continuar</p>
        <Link to="/loja"><Button className="bg-fuchsia-500 hover:bg-fuchsia-600">Explorar Produtos</Button></Link>
      </div>
    );
  }

  return (
    <div className="grid md:grid-cols-3 gap-6">
      <div className="md:col-span-2 space-y-3">
        <h1 className="text-2xl font-bold mb-4">Seu Carrinho</h1>
        {cart.map(item => (
          <Card key={item.product_id} className="bg-slate-900 border-slate-800 p-4 flex items-center gap-4">
            <div className="w-16 h-16 bg-slate-800 rounded-lg flex-shrink-0" />
            <div className="flex-1 min-w-0">
              <h3 className="font-semibold truncate">{item.name}</h3>
              <p className="text-fuchsia-400 font-bold">R$ {item.price.toFixed(2)}</p>
            </div>
            <div className="flex items-center border border-slate-700 rounded-lg">
              <button onClick={() => updateQty(item.product_id, item.quantity - 1)} className="px-2 py-1 hover:bg-slate-800"><Minus className="w-3 h-3" /></button>
              <span className="px-3 min-w-[32px] text-center text-sm">{item.quantity}</span>
              <button onClick={() => updateQty(item.product_id, item.quantity + 1)} className="px-2 py-1 hover:bg-slate-800"><Plus className="w-3 h-3" /></button>
            </div>
            <button onClick={() => removeFromCart(item.product_id)} className="p-2 text-red-400 hover:bg-red-500/10 rounded-lg"><Trash2 className="w-4 h-4" /></button>
          </Card>
        ))}
      </div>
      <div>
        <Card className="bg-slate-900 border-slate-800 p-5 sticky top-24">
          <h3 className="font-bold mb-4">Resumo</h3>
          <div className="flex justify-between text-sm mb-2"><span className="text-slate-400">Subtotal</span><span>R$ {cartTotal.toFixed(2)}</span></div>
          <div className="flex justify-between text-lg font-bold border-t border-slate-800 pt-3 mt-3"><span>Total</span><span className="text-fuchsia-400">R$ {cartTotal.toFixed(2)}</span></div>
          <Button onClick={() => navigate(user ? '/loja/checkout' : '/loja/login?redirect=/loja/checkout')} className="w-full mt-6 bg-fuchsia-500 hover:bg-fuchsia-600">
            Finalizar Compra <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
        </Card>
      </div>
    </div>
  );
}
